<template>
  <v-app>
    <v-main>
      <vue-topprogress ref="topProgress" :color="loader.color"></vue-topprogress>
      <v-alert colored-border border="bottom" elevation="2" dismissible v-if="alert.message" v-bind:type="`${alert.type}`">
        {{ alert.message }}
      </v-alert>
      <RouterView></RouterView>
    </v-main>
  </v-app>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import { vueTopprogress } from 'vue-top-progress'

export default {
  name: "App",
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    ...mapState({
      loader: (state) => state.loader,
    }),
    loadingLoader() {
      return this.loader.loading;
    }
  },
  components: {
    vueTopprogress
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
    }),
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearAlert();
    },
    loadingLoader(loading) {
      if(loading) {
        this.$refs.topProgress.start();
      } else {
        this.$refs.topProgress.done();
      }
    }
  },
};
</script>
